var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 1.5C15.4 1.8 14.8 1.9 14.1 2C14.8 1.6 15.3 1 15.5 0.2C14.9 0.6 14.2 0.8 13.4 1C12.8 0.4 11.9 0 11 0C9.3 0 7.8 1.5 7.8 3.3C7.8 3.6 7.8 3.8 7.9 4C5.2 3.9 2.7 2.6 1.1 0.6C0.8 1.1 0.7 1.6 0.7 2.3C0.7 3.4 1.3 4.4 2.2 5C1.7 5 1.2 4.8 0.7 4.6C0.7 6.2 1.8 7.5 3.3 7.8C3 7.9 2.7 7.9 2.4 7.9C2.2 7.9 2 7.9 1.8 7.8C2.2 9.1 3.4 10.1 4.9 10.1C3.8 11 2.4 11.5 0.8 11.5C0.5 11.5 0.3 11.5 0 11.5C1.5 12.4 3.2 13 5 13C11 13 14.3 8 14.3 3.7C14.3 3.6 14.3 3.4 14.3 3.3C15 2.8 15.6 2.2 16 1.5Z",
    fill: "#C9D1CF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 1.5C15.4 1.8 14.8 1.9 14.1 2C14.8 1.6 15.3 1 15.5 0.2C14.9 0.6 14.2 0.8 13.4 1C12.8 0.4 11.9 0 11 0C9.3 0 7.8 1.5 7.8 3.3C7.8 3.6 7.8 3.8 7.9 4C5.2 3.9 2.7 2.6 1.1 0.6C0.8 1.1 0.7 1.6 0.7 2.3C0.7 3.4 1.3 4.4 2.2 5C1.7 5 1.2 4.8 0.7 4.6C0.7 6.2 1.8 7.5 3.3 7.8C3 7.9 2.7 7.9 2.4 7.9C2.2 7.9 2 7.9 1.8 7.8C2.2 9.1 3.4 10.1 4.9 10.1C3.8 11 2.4 11.5 0.8 11.5C0.5 11.5 0.3 11.5 0 11.5C1.5 12.4 3.2 13 5 13C11 13 14.3 8 14.3 3.7C14.3 3.6 14.3 3.4 14.3 3.3C15 2.8 15.6 2.2 16 1.5Z",
    fill: "black",
    fillOpacity: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.df148826edac14b1316c7943fbe3e7be.svg";
export { ForwardRef as ReactComponent };